module.exports = __webpack_public_path__ + "8bd07b264ee50f6e93dac01925d8b5bb.svg";